module.exports = __webpack_public_path__ + "img/mpos-white.6c461d10.png";